<script>
    let galleryitems = [
        "Alphonso-home-1.jpg",
        "171676_141964912534516_3469083_o-1.jpg",
        "176244_141965425867798_6545261_o-1.jpg",
        "BBQ-2-1.jpg",
        "BBQ-3-1.jpg",
        "BBQ-img-22-1.jpg",
        "Beach-wood-img-2-1.jpg",
        "Cocktail-Package-image-1.jpg",
        "Food-img-21-1.jpg",
        "gallery-2-2.jpg",
        "Gallery-1-2.jpg",
        "Gallery-3-2.jpg",
        "Gallery-4-2.jpg",
        "Gallery-6-2.jpg",
        "Image-22-6-1.jpg",
        "image-ducks-1.jpg",
        "IMG_8693-1.jpg",
        "IMG_8731-1.jpg",
        "IMG_8783-1.jpg",
        "IMG_8827-1.jpg",
        "IMG_9049-1.jpg",
        "IMG_9255-1.jpg",
        "Imgage-22-1-1.jpg",
        "Wooden-Cottage-home-2.jpg"
    ]
</script>

<div class="color-background" style="background-color:#0C2149;">
    <h1 class="header_text_wrapper text-left"><span>Gallery</span><span class="separator"></span></h1>
</div>
<div id="primary" class="content-area container-fluid">
    <div class="top-35 bottom-35">
        <div id="carouselExampleControls" class="carousel slide" data-bs-ride="carousel">
            <div class="carousel-inner">
                {#each galleryitems as item, i}
                    <div class="carousel-item {i == 0 ? 'active' : ''}">
                        <img src="/images/gallery/{item}" class="d-block w-100" alt="{item}">
                    </div>
                {/each}
            </div>
            <button class="carousel-control-prev" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="prev">
                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Previous</span>
            </button>
            <button class="carousel-control-next" type="button" data-bs-target="#carouselExampleControls" data-bs-slide="next">
                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                <span class="visually-hidden">Next</span>
            </button>
        </div>
    </div>
</div>

<style>
    .bottom-35 {
        padding-bottom: 35px;
    }

    .top-35 {
        padding-top: 35px;
    }
</style>